

<div class="container mt-5">
  <div class="card card-primary">
    <div *ngIf="loader==true">
      <app-loader style="text-align: center;"></app-loader>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <div class="row">
      <form id="quickForm" [formGroup]="eventForm" (ngSubmit)="onSubmit(skuNumber.value)">
        <div class="card-body">
         <div class="row">
          <div class="col-5">
            <div class="form-group">
              <app-form-field label="{{ 'SKU' }}" [required]="true" [control]="eventForm.controls['SKU']"
                [isInline]="false">
                <!-- <app-input formControlName="SKU"></app-input> -->
                 <input type="text" class="form-control form-control-lg" [value]="skuValue" #skuNumber>
                 <a (click)="generateRandomString()" style="cursor: pointer; color: blue;">Generate New</a>
              </app-form-field>
            </div>
          </div>
         <div class="col-2">

         </div>
         <div class="col-5">
          <div class="form-group">
            <app-form-field label="{{ 'Product Name' }}" [required]="true" [control]="eventForm.controls['ProductName']"
              [isInline]="false">
              <app-input formControlName="ProductName"></app-input>
            </app-form-field>
          </div>
         </div>
         </div>
          <div class="row">
            <div class="col-5">
              <div class="form-group">
                <app-form-field label="{{ 'Description' }}" [required]="true" [control]="eventForm.controls['Description']"
                  [isInline]="false">
                  <app-input formControlName="Description"></app-input>
                </app-form-field>
              </div>
            </div>
            <div class="col-2"> </div>
            <div class="col-5">
              <div class="form-group">
                <app-form-field label="{{ 'Distributor Price' }}" [required]="true" [control]="eventForm.controls['DistributorPrice']"
                  [isInline]="false">
                  <app-input formControlName="DistributorPrice"></app-input>
                </app-form-field>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-5">
              <div class="form-group">
                <app-form-field label="{{ 'Retail Price' }}" [required]="true" [control]="eventForm.controls['RetailPrice']"
                  [isInline]="false">
                  <app-input formControlName="RetailPrice"></app-input>
                </app-form-field>
              </div>
            </div>
            <div class="col-2"></div>
            <div class="col-5">
              <div class="form-group">
                <app-form-field label="{{ 'Unit' }}" [required]="true" [control]="eventForm.controls['Unit']"
                  [isInline]="false">
                  <app-input formControlName="Unit"></app-input>
                </app-form-field>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-5">
              <mat-form-field appearance="fill" style="width: 100%;">
                <mat-label>Locations</mat-label>
                <mat-select [formControl]="toppings" [(ngModel)]="selectedOptions" multiple>
                  <mat-option *ngFor="let option of options" [value]="option.value">{{ option.viewValue }}</mat-option>
                </mat-select>
              </mat-form-field>
      
            </div>
            <div class="col-2"></div>
            <div class="col-5">
              <div class="form-group">
                <app-form-field label="{{ 'CategoryId' }}" [required]="true" [control]="eventForm.controls['CategoryId']"
                  [isInline]="false">
                  <app-select [items]="categoryData" formControlName="CategoryId"></app-select>
                </app-form-field>
              </div>
            </div>
          </div>
          
          <div class="row">
            
            <div class="col-5">
              <div class="form-group">

                <app-form-field label="{{ 'Product Type' }}" [required]="true" [control]="eventForm.controls['ProductType']"
                  [isInline]="false">
                  <app-select [items]="productType" formControlName="ProductType"></app-select>
                 
                </app-form-field>
              </div>
            </div>

            <div class="col-lg-2">

            </div>
            <div class="col-5">
              <div class="form-group">
                <app-form-field label="{{ 'Stock' }}" [required]="true" [control]="eventForm.controls['TotalStock']"
                  [isInline]="false">
                  <!-- <app-input formControlName="Stock"></app-input> -->
                   <input type="number" formControlName="TotalStock" class="form-control form-control-lg">
                </app-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5">
              <app-form-field label="{{ 'image' }} JPEG/PNG" [required]="false" [isInline]="false">
                <input id="file" class="form-control form-control-lg" type="file" (change)="setUserOrPassportImage($event)" />
              </app-form-field>
            </div>
          </div>
        </div>
        <!-- /.card-body -->
        <div class="card-footer">
          <button type="button" class="btn btn-primary" (click)="onSubmit(skuNumber.value)">Submit</button> &nbsp;&nbsp;
          <button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss({ refresh: false })">
            Close
          </button>
        </div>
      </form>
    </div>
  </div>


</div>
<script src="../../plugins/jquery/jquery.min.js"></script>
<script src="../../plugins/bootstrap/js/bootstrap.bundle.min.js"></script>
<!-- Select2 -->
<script src="../../../../assets/plugins/select2/js/select2.full.min.js"></script> 

<script>
  $(function () {
    //Initialize Select2 Elements
    $('.select2').select2()

    //Initialize Select2 Elements
    $('.select2bs4').select2({
      theme: 'bootstrap4'
    })
  })
</script>